// Estetica Elite — Site constants
export const SITE = {
  name: "Estetica Elite",
  tagline: "Bellezza · Benessere · Solarium",
  city: "Venezia Mestre",
  address: "Via Don Federico Tosatto 22, 30174 Venezia (Mestre)",
  phone: "041 989574",
  phoneTel: "tel:+39041989574",
  treatwell:
    "https://www.treatwell.it/salone/elite-7/?utm_source=google&utm_medium=rwg",
  maps:
    "https://www.google.com/maps/dir/?api=1&destination=Via+Don+Federico+Tosatto+22+30174+Venezia+VE",
  mapsEmbed:
    "https://www.google.com/maps?q=Via%20Don%20Federico%20Tosatto%2022%2C%2030174%20Venezia%20VE&output=embed",
  ratings: {
    treatwell: { score: "4,9", count: 775 },
    google: { score: "4,3", count: 130 },
  },
};

export const LOGO = "/images/logo-ee.png";

// Foto reali del centro Estetica Elite (Mestre).
// Nomi semantici: ogni costante punta alla foto descritta.
export const PHOTOS = {
  team: "/images/team.jpg",                       // A
  cabinaTulipani: "/images/cabina-tulipani.jpg",  // B
  corridoio: "/images/corridoio.jpg",             // C
  manicurePostazione: "/images/manicure-postazione.jpg", // D
  macchinario: "/images/macchinario.jpg",         // E
  portaLineArt: "/images/porta-line-art.jpg",     // F
  bancoAccoglienza: "/images/banco-accoglienza.jpg", // G
  vetrina: "/images/vetrina.jpg",                 // H
  salaAttesa: "/images/sala-attesa.jpg",          // I
  solariumIngresso: "/images/solarium-ingresso.jpg", // J
};

// Slideshow Hero — 3 slide in rotazione (4s ciascuna).
export const HERO_SLIDES = [
  {
    src: PHOTOS.team,
    alt: "Il team di Estetica Elite Mestre",
    objectPosition: "center 20%",
  },
  {
    src: PHOTOS.vetrina,
    alt: "Estetica Elite vetrina esterna",
    objectPosition: "center",
  },
  {
    src: PHOTOS.corridoio,
    alt: "Interno centro estetico Mestre",
    objectPosition: "center",
  },
];

// Galleria "Il nostro centro" — 3 foto verticali side-by-side.
export const CENTRO_GALLERY = [
  { src: PHOTOS.cabinaTulipani, alt: "Cabina trattamento Estetica Elite" },
  { src: PHOTOS.bancoAccoglienza, alt: "Accoglienza con prodotti Germaine de Capuccini" },
  { src: PHOTOS.salaAttesa, alt: "Sala d'attesa Estetica Elite" },
];
